import { createStore } from "redux";
import { regionReducer } from "./modules/common/components/RegionDetect/reducer.tsx";

export const store = createStore(regionReducer);
